import { render } from "./TeacherList.vue?vue&type=template&id=35293ad2&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import "./TeacherList.vue?vue&type=style&index=0&id=35293ad2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35293ad2"]])

export default __exports__